import React from "react";

const ScoreEditModal = ({
  matchId,
  score,
  onChange,
  onCancel,
  onSave,
  team1Name = "Équipe 1",
  team2Name = "Équipe 2",
  goalsToWin = 1,
}) => {

  const handleScoreChange = (teamKey, value) => {
    const newScore = parseInt(value);
    const otherTeamKey = teamKey === "team1" ? "team2" : "team1";

    // If a team scored less than goalsToWin, set the other team to goalsToWin
    if (newScore < goalsToWin) {
      onChange(matchId, teamKey, newScore);
      onChange(matchId, otherTeamKey, goalsToWin);
    } else {
      onChange(matchId, teamKey, newScore);
    }
  };

  const handleReset = () => {
    onChange(matchId, "team1", null);
    onChange(matchId, "team2", null);
  };

  const generateOptions = () => {
    const options = [];
    for (let i = 0; i <= goalsToWin; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return options;
  };
  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
      <div className="bg-slate-900 border border-slate-700 text-slate-50 rounded-xl p-5 w-full max-w-sm mx-4">
        <h2 className="text-lg font-bold mb-4 text-center">Modifier le score</h2>

        <div className="flex items-center justify-center gap-4 mb-5">
          {/* Team 1 */}
          <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
            <div
              className="w-full text-sm font-medium text-center text-slate-300 overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {team1Name}
            </div>
            <select
              className="w-full bg-slate-800 text-slate-50 text-2xl font-bold text-center py-3 rounded-lg border border-slate-600 focus:border-blue-400 focus:outline-none appearance-none"
              value={Number(score?.team1) || 0}
              onChange={(e) => handleScoreChange("team1", e.target.value)}
            >
              {generateOptions()}
            </select>
          </div>

          {/* VS separator */}
          <div className="text-sm font-bold text-slate-500 pt-5">–</div>

          {/* Team 2 */}
          <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
            <div
              className="w-full text-sm font-medium text-center text-slate-300 overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {team2Name}
            </div>
            <select
              className="w-full bg-slate-800 text-slate-50 text-2xl font-bold text-center py-3 rounded-lg border border-slate-600 focus:border-blue-400 focus:outline-none appearance-none"
              value={Number(score?.team2) || 0}
              onChange={(e) => handleScoreChange("team2", e.target.value)}
            >
              {generateOptions()}
            </select>
          </div>
        </div>

        <div className="flex gap-2">
          <button
            className="flex-1 px-2 py-2.5 bg-red-700 hover:bg-red-600 text-white text-sm rounded-lg"
            onClick={handleReset}
          >
            Réinitialiser
          </button>
          <button
            className="flex-1 px-2 py-2.5 bg-slate-600 hover:bg-slate-500 text-white text-sm rounded-lg"
            onClick={onCancel}
          >
            Annuler
          </button>
          <button
            className="flex-[2] py-2.5 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg"
            onClick={() => onSave(matchId)}
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScoreEditModal;
